import { browserPageReducer } from '../slices/browserPage';
import { chatReducer } from '../slices/chat';
import { jsonQueryReducer } from '../slices/jsonQuery';
import { listingLayoutReducer } from '../slices/listingLayout';
import { mapConfigurationReducer } from '../slices/mapConfiguration';
import { mapControlsReducer } from '../slices/mapControls';

export const reduxReducer = {
  browserPage: browserPageReducer,
  chat: chatReducer,
  jsonQuery: jsonQueryReducer,
  listingLayout: listingLayoutReducer,
  mapConfiguration: mapConfigurationReducer,
  mapControls: mapControlsReducer,
};
